import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { FaLock } from "react-icons/fa";
import "../css/profile.css";

import {
  FaUserCircle,
  FaShoppingBag,
  FaMapMarkerAlt,
  FaEdit,
  FaHeart,
  FaShoppingCart
} from "react-icons/fa";

function Profile() {

  const userId = localStorage.getItem("user_id");

  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: ""
  });

  useEffect(() => {

    if (!userId) return;

    axios
      .get(`http://localhost:5000/api/profile/${userId}`)
      .then((res) => {
        setUser(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [userId]);

  return (
    <div className="profile-page">

      {/* Hero */}

      <section className="profile-hero">

        <div className="profile-overlay">

          <FaUserCircle className="profile-avatar" />

          <h1>
            {user.first_name} {user.last_name}
          </h1>

          <p>{user.email}</p>

          <p>{user.phone}</p>

        </div>

      </section>

      {/* Dashboard */}

      <section className="profile-section">

        <div className="profile-container">

          <div className="profile-grid">

            <Link to="/my-orders" className="profile-card">

              <FaShoppingBag className="profile-icon" />

              <h3>My Orders</h3>

              <p>View all your orders.</p>

            </Link>

            <Link to="/addresses" className="profile-card">

              <FaMapMarkerAlt className="profile-icon" />

              <h3>Saved Addresses</h3>

              <p>Manage shipping addresses.</p>

            </Link>

            <Link to="/edit-profile" className="profile-card">

              <FaEdit className="profile-icon" />

              <h3>Edit Profile</h3>

              <p>Update your account information.</p>

            </Link>
<Link to="/change-password" className="profile-card">

  <FaUserCircle className="profile-icon" />

  <h3>Change Password</h3>

  <p>Update your account password.</p>

</Link>
            <Link to="/wishlist" className="profile-card">

              <FaHeart className="profile-icon" />

              <h3>Wishlist</h3>

              <p>Your favourite products.</p>

            </Link>

            <Link to="/cart" className="profile-card">

              <FaShoppingCart className="profile-icon" />

              <h3>Shopping Cart</h3>

              <p>Review items in your cart.</p>

            </Link>

          </div>

        </div>

      </section>

    </div>
  );
}

export default Profile;